import { useDispatch, useSelector } from 'react-redux';

import { baseApi } from '@shared/api/baseApi';
import {
	activatePrivateContext,
	logOutLocal,
	selectAccessToken,
	selectRefreshToken,
} from '@shared/api/reduxToolkit';
import { useLogOutMutation } from '@shared/api/rtkQuery';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { LOGGED_OUT_KEY } from '@shared/constants';
import { useBrandTheme } from '@shared/lib/brandTheme';
import { showCustomToast, TOAST_TYPES } from '@shared/ui/toast';

export const useLogOut = () => {
	const dispatch = useDispatch();
	const [logOut, { isLoading }] = useLogOutMutation();
	const { cidaasClientId, cidaasBaseUrl } = useBrandTheme();
	const refreshToken = useSelector(selectRefreshToken);
	const accessToken = useSelector(selectAccessToken);

	const handleLogOut = async () => {
		if (!cidaasBaseUrl || !cidaasClientId) {
			showCustomToast(TOAST_TYPES.ERROR, { key: Translation.LOGOUT_ERROR, ns: i18TranslationNS });
			return;
		}
		try {
			await logOut(refreshToken).unwrap();
		} catch {
			// logout API failure is non-fatal — local cleanup always runs
		}

		dispatch(logOutLocal());
		dispatch(activatePrivateContext());
		dispatch(baseApi.util.resetApiState());

		const url = new URL(`${cidaasBaseUrl.replace(/\/$/, '')}/session/end_session`);
		url.searchParams.set('client_id', cidaasClientId);
		url.searchParams.set('post_logout_redirect_uri', window.location.origin);
		// cidaas requires access_token_hint or id_token_hint to accept the end_session request
		// without it cidaas returns AATON1018: access_token_hint or id_token_hint is required
		if (accessToken) url.searchParams.set('access_token_hint', accessToken);
		sessionStorage.setItem(LOGGED_OUT_KEY, '1');
		window.location.href = url.toString();
	};

	return { handleLogOut, isLoading };
};
